"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Shop() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="2025" id="shop-title" className="relative bg-background text-foreground overflow-hidden dark !p-0">
      <span aria-hidden="true" className="pointer-events-none absolute top-6 left-6 text-muted-foreground/60 font-mono text-xs leading-none select-none">
        +
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute top-6 right-6 text-muted-foreground/60 font-mono text-xs leading-none select-none">
        +
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute bottom-6 left-6 text-muted-foreground/60 font-mono text-xs leading-none select-none">
        +
      </span>
      <span aria-hidden="true" className="pointer-events-none absolute bottom-6 right-6 text-muted-foreground/60 font-mono text-xs leading-none select-none">
        +
      </span>

      <div className="container mx-auto max-w-[1440px] px-6 md:px-12">
        <div ref={ref} className={`grid grid-cols-1 gap-12 lg:gap-8 transition-all duration-[720ms] ease-[cubic-bezier(0.2,0.7,0.2,1)] justify-center items-center ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="lg:col-span-12 flex flex-col items-center text-center">
            <div className="flex items-center gap-3 mb-10 md:mb-14">
              
              
            </div>

            <div className="flex flex-col items-center text-center">
              <h1 className="font-default font-semibold text-foreground leading-[0.95] tracking-[-0.03em] text-[clamp(2.75rem,6.5vw,6.5rem)]">
                <span className="block">Wear the</span>
                <span className="block italic text-primary font-default">
                  mission
                </span>
                <span className="block">forward</span>
              </h1>

              <p className="mt-10 font-default text-foreground/90 max-w-[50ch] leading-[1.6] tracking-[-0.005em] !text-3xl md:mt-12">
                Our limited-edition apparel supports critical humanitarian causes. 
                Every piece is designed to spark conversation and keep awareness 
                issues forever fresh in the public consciousness. Join the movement.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-20 md:mt-28 flex items-center gap-2">
          <span aria-hidden="true" className="flex-1 h-px bg-border" />
          <span aria-hidden="true" className="inline-block h-1.5 w-1.5 rounded-lg bg-primary shrink-0" />
        </div>
      </div>
    </section>;
}